import { FormControl, FormGroup } from '@angular/forms';
import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';

export type RadioOptions = {
  label: string,
  value: string
}

@Component({
  selector: 'app-combo-text-area',
  templateUrl: './combo-text-area-with-title.component.html',
  styleUrls: ['./combo-text-area-with-title.component.scss']
})
export class ComboTextAreaWithTitleComponent implements OnInit, OnChanges {

  @Input() title: string = '';
  @Input() height: string = '';
  @Input() width: string = '809px';
  @Input() inputText: FormControl = new FormControl();
  @Input() isFirstQuestionnaire!: boolean; // funciona como campo 'required'
  @Input() customClass: string = '';

  @Input() valid: boolean | null = null; // se for null, considera que não há validação pra componente

  radioValue = '';

  testControl = new FormControl()


  @Input() radioOptionsHeader: null | RadioOptions[] = null

  optionsLabels: string[] = []

  voice: string = '';
  panelExpanded: boolean = true;

  constructor() {
  }

  ngOnInit(): void {
    this.resetRadiosOnTextChangeSubs()
  }

  resetRadiosOnTextChangeSubs() {
    if (this.radioOptionsHeader == null || this.radioOptionsHeader.length == 0) {
      return
    }
    this.inputText.valueChanges.subscribe(text => {
      const index = this.radioOptionsHeader!.findIndex(option => option.value == text)

      if (index >= 0) { // user digitou valor de alguma opção dos radios
        return
      }
      // user digitou opção distinta, então é para dar reset nos radios
      this.radioValue = '';
      // this.radioValue = text;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    // console.log(['init' , this.radioOptionsHeader?.length])
    if (changes['radioOptionsHeader']) {
      this.optionsLabels = this.radioOptionsHeader?.map(i => i.label) ?? []
    }
    if (changes['width']) {
      this.width = changes['width'].currentValue;
    }
  }

  applyHeight() {
    return { 'min-height': this.height };
  }

  log() {
    this.testControl.patchValue(this.inputText.value)
  }

  autoResize(event: Event) {

    const textarea = event.target as HTMLTextAreaElement;

    if (textarea) {

      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';

      if (textarea.offsetHeight > textarea.scrollHeight) {

        textarea.style.height = `${textarea.offsetHeight}px`;
      }
    }
  }

  itemSelected(item: string) {
    // this.inputText.patchValue(item)
    const index = this.optionsLabels.indexOf(item)
    this.radioValue = item;

    // se está chamando essa func, então radioOptions possui items
    if (index > -1) {
      const originalItem = this.radioOptionsHeader![index]
      this.inputText.patchValue(originalItem.value)
    }
    // console.log({item, index , originalItem})
  }

  recebeVoice(event: any) {
    this.voice = event;
    if (this.inputText.value === "") {
      this.inputText.setValue(this.voice)
    }
    else {
      this.inputText.setValue(this.inputText.value + " " + this.voice)
    }
  }

}
